import { useCallback, useEffect, useState } from 'react';
import { filterColumn } from '@components/UI/Filter';
import { TableColumnType, SorterResult } from 'antd';
import type { FilterValue } from 'antd';
import assert from 'assert';

type FalsableColumn<Row> = (TableColumnType<Row> & { filterable?: any; dateFilter?: any; hideOn?: string[]; visibleOn?: string[] }) | false;

export function useColumnFilters<Row>(columns: FalsableColumn<Row>[]) {
  const [filteredColumns, setFilteredColumns] = useState(
    columns.filter((c) => c) as Exclude<FalsableColumn<Row>, false>[]
  );
  const [query, setQuery] = useState({});

  const handleTableChange = useCallback(
    (
      pagination: unknown,
      filters: Record<string, FilterValue | null>,
      sorter: SorterResult<Row> | SorterResult<Row>[]
    ) => {
      const orderTypes = { undefined: 'desc', ascend: 'asc', descend: 'desc' };
      assert(!Array.isArray(sorter), 'Cannot process multiple table sort conditions');
      setQuery((query) => ({
        ...query,
        sort: sorter.order !== undefined ? sorter.columnKey : Object.keys(filters)[0],
        order: orderTypes[sorter.order || 'undefined']
      }));
    },
    []
  );

  useEffect(() => {
    const properCols = columns.filter((c) => c) as Exclude<FalsableColumn<Row>, false>[];

    setFilteredColumns(
      properCols.map((c) => {
        if (c.filterable) {
          const { exact, queryKey } = c.filterable === true ? { exact: false, queryKey: c.dataIndex } : c.filterable;
          return { ...c, ...filterColumn(c.title, queryKey, setQuery, query, exact, c.dateFilter) };
        }
        return c;
      })
    );
  }, [columns, query]);
  return { columns: filteredColumns, query, handleTableChange };
}

export default useColumnFilters;
